import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import cx from 'classnames';

import theme from './styles.module.scss';

const Page = ({ children, className, background, borderBottom }) => (
  <div
    className={cx(theme.sectionContainer, className)}
    style={{
      background: background,
      borderBottom: borderBottom,
    }}
  >
    <div className="section-container__wrap">{children}</div>
  </div>
);

Page.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  background: PropTypes.string,
  borderBottom: PropTypes.string,
};

export default withRouter(Page);
